export default __webpack_public_path__ + "static/media/hammer.b80aaf6e.png";